/**
 * Request bodies for `/api/auth` (backend.md §4.2). The web forms parse with the
 * same objects, so a field the server would reject never leaves the browser.
 */
import { z } from 'zod';
import { emailSchema, localeSchema, passwordSchema, usernameSchema, verificationCodeSchema, } from './common.js';
export const registerBodySchema = z.object({
    username: usernameSchema,
    email: emailSchema,
    password: passwordSchema,
    locale: localeSchema.optional(),
});
export const verifyBodySchema = z.object({
    email: emailSchema,
    code: verificationCodeSchema,
});
export const resendVerificationBodySchema = z.object({ email: emailSchema });
/**
 * `identifier` is a username *or* an email, so it cannot carry either schema's
 * constraints — the lookup is `lower(username) = $1 OR lower(email) = $1` and a
 * miss is answered with the same flat-timing 401 as a bad password (§6.3).
 */
export const loginBodySchema = z.object({
    identifier: z.string().trim().min(3).max(254),
    password: z.string().min(1).max(128),
});
export const forgotPasswordBodySchema = z.object({ email: emailSchema });
export const resetPasswordBodySchema = z.object({
    token: z.string().trim().min(16).max(256),
    password: passwordSchema,
});
//# sourceMappingURL=auth.js.map